import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';

export const specialLocations = {
  'de': {
    'country.8804': createResourceLocatorString(
      'StoryblokPage',
      routeConfiguration(),
      { slug: 'wohnmobilstellplatz', rest: 'kroatien' },
      {},
      'de',
    ),
  },
};